export const getRolePrefix = (roleName: string): string => {
  if (!roleName) return "";
  return "/" + roleName.toLowerCase().replace(/\s+/g, "-");
};

export const RoutesLink = {
  // Auth Routes
  authRoutes: {
    login: "/",
    ssoLogin: "/sso-login",
    forgot: "/forgot",
    signUp: "/join-now",
    verifyOtp: "/verify-otp",
    resetPassword: "/reset-password",
  },
  forbidden_403: "/forbidden-403",
  superAdminDashboard: "/super-admin/dashboard",
  superAdminEmployees: "/super-admin/employees",
  createEmployee: "/super-admin/create-employee",
  editEmployee: "/super-admin/edit-employee",
  employeeDetail: "/super-admin/employee-detail",

  // Profile
  profile: "/super-admin/profile",
  editProfile: "/super-admin/edit-profile",
  // viewProfile: "/super-admin/view-profile/",

  // Company
  company: "/super-admin/company",
  createCompany: "/super-admin/create-company",
  editCompany: "/super-admin/edit-company",

  //   department
  superAdminDepartment: "/super-admin/department",
  addDepartment: "/super-admin/add-department",
  editDepartment: "/super-admin/edit-department",
  //   branch
  superAdminBranch: "/super-admin/branch",
  addBranch: "/super-admin/add-branch",
  editBranch: "/super-admin/edit-branch",
  //   shift and time
  shiftAndTime: "/super-admin/shift-and-time",
  addShiftAndTime: "/super-admin/add-shift-and-time",
  editShiftAndTime: "/super-admin/edit-shift-and-time",

  //   designation
  superAdminDesignation: "/super-admin/designation",
  addDesignation: "/super-admin/add-designation",
  editDesignation: "/super-admin/edit-designation",

  // campus
  superAdminCampus: "/super-admin/campus",
  addCampus: "/super-admin/add-campus",
  editCampus: "/super-admin/edit-campus",

  // applications
  superAdminApplication: "/super-admin/application",
  addApplication: "/super-admin/add-application",
  editApplication: "/super-admin/edit-application",

  // Common Routes
  dashboard: "/super-admin/dashboard",
  // forbidden_403: "/forbidden-403",

  // Super Admin Routes
  // superAdminDashboard: "/super-admin/dashboard",

  // Leave Setting
  leaveSetting: "/leave-setting",
  addLeaveSetting: "/add-leave-setting",
  editLeaveSetting: "/edit-leave-setting",

  // Leave
  addLeave: "/super-admin/add-leave",
  editLeave: "/super-admin/edit-leave",
  leaveDetail: "/super-admin/leave-detail",
  teamLeave: "/super-admin/team-leave",
  myLeave: "/super-admin/my-leave",

  // Admin Routes
  adminCompare: "/admin/compare",
  adminOrg: "/admin/org",
  adminTemplates: "/admin/templates",
  adminAudit: "/admin/audit",
  adminSettings: "/admin/settings",

  // Site
  superAdminSite: "/super-admin/site",
  addSite: "/super-admin/add-site",
  editSite: "/super-admin/edit-site",
};
// };
